var ALLOWED_TAGS = new Set([
    "a",
    "b",
    "blockquote",
    "br",
    "div",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "i",
    "li",
    "mark",
    "ol",
    "p",
    "span",
    "strong",
    "table",
    "tbody",
    "td",
    "th",
    "thead",
    "tr",
    "u",
    "ul",
]);
var BLOCKED_TAGS = new Set([
    "button",
    "embed",
    "form",
    "iframe",
    "input",
    "math",
    "object",
    "script",
    "style",
    "svg",
]);
var ALLOWED_ATTRIBUTES = new Set([
    "align",
    "colspan",
    "data-empty-placeholder",
    "href",
    "rel",
    "rowspan",
    "target",
    "title",
]);
var URL_ATTRIBUTES = new Set(["href"]);
var ALLOWED_URL_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);
var escapeHtml = function (value) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
};
var sanitizeUrl = function (value) {
    var trimmed = value.trim();
    if (!trimmed)
        return null;
    if (trimmed.startsWith("#"))
        return trimmed;
    try {
        var url = new URL(trimmed, window.location.origin);
        return ALLOWED_URL_PROTOCOLS.has(url.protocol) ? trimmed : null;
    }
    catch (_a) {
        return null;
    }
};
var sanitizeAttribute = function (element, name, value) {
    var attributeName = name.toLowerCase();
    if (attributeName.startsWith("on"))
        return;
    if (!ALLOWED_ATTRIBUTES.has(attributeName))
        return;
    if (URL_ATTRIBUTES.has(attributeName)) {
        var sanitizedUrl = sanitizeUrl(value);
        if (sanitizedUrl)
            element.setAttribute(attributeName, sanitizedUrl);
        return;
    }
    if (attributeName === "target" && !["_blank", "_self"].includes(value)) {
        return;
    }
    element.setAttribute(attributeName, value);
};
var sanitizeNode = function (node, documentRef) {
    var _a;
    if (node.nodeType === Node.TEXT_NODE) {
        return documentRef.createTextNode((_a = node.textContent) !== null && _a !== void 0 ? _a : "");
    }
    if (node.nodeType !== Node.ELEMENT_NODE) {
        return documentRef.createDocumentFragment();
    }
    var sourceElement = node;
    var tagName = sourceElement.tagName.toLowerCase();
    var fragment = documentRef.createDocumentFragment();
    if (BLOCKED_TAGS.has(tagName)) {
        return fragment;
    }
    if (!ALLOWED_TAGS.has(tagName)) {
        sourceElement.childNodes.forEach(function (child) {
            fragment.appendChild(sanitizeNode(child, documentRef));
        });
        return fragment;
    }
    var cleanElement = documentRef.createElement(tagName);
    Array.from(sourceElement.attributes).forEach(function (attribute) {
        sanitizeAttribute(cleanElement, attribute.name, attribute.value);
    });
    if (tagName === "a" && cleanElement.getAttribute("target") === "_blank") {
        cleanElement.setAttribute("rel", "noopener noreferrer");
    }
    sourceElement.childNodes.forEach(function (child) {
        cleanElement.appendChild(sanitizeNode(child, documentRef));
    });
    return cleanElement;
};
export var sanitizeHtml = function (html) {
    if (typeof document === "undefined" || typeof DOMParser === "undefined") {
        return escapeHtml(html);
    }
    var sourceDocument = new DOMParser().parseFromString(html, "text/html");
    var targetDocument = document.implementation.createHTMLDocument("");
    var container = targetDocument.createElement("div");
    sourceDocument.body.childNodes.forEach(function (node) {
        container.appendChild(sanitizeNode(node, targetDocument));
    });
    return container.innerHTML;
};
